var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("其他险种出险-详情")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "540px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "padding": "100px",
      "overflow-x": "hidden"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("|   ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "150px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "label": "保单名称",
      "prop": "name"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$parent.ruleForm.insurance_name) + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "label": "保单号",
      "prop": "name"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$parent.ruleForm.policy_no) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "唯一识别码",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.detailed_id) + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称/品牌",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.brand) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "规格型号",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.model) + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("|   ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("出险信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-left": "120px"
    }
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "label": "出险时间",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.danger_time) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "出险经过",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.danger_after) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "事故照片",
      "prop": "name"
    }
  }, _vm._l((_vm.$parent.ruleForm.accident_photo), function(item, index) {
    return _c('img', {
      key: index,
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "src": item,
        "height": "150px"
      }
    })
  }), 0)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "报案号",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.report_no) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "保单号",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.policy_no) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "理赔情况",
      "prop": "region"
    }
  }, [_vm._v("\n                 " + _vm._s(_vm.$parent.ruleForm.settlement_status) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "医疗票据",
      "prop": "region"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.$parent.ruleForm.bill_url,
      "height": "150px"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "收保险公司理赔款",
      "prop": "region"
    }
  }, [_vm._v("\n                 " + _vm._s(_vm.$parent.ruleForm.settlement_amount) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "付员工理赔款",
      "prop": "region"
    }
  }, [_vm._v("\n                 " + _vm._s(_vm.$parent.ruleForm.indemnity_amount) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "结案日期",
      "prop": "region"
    }
  }, [_vm._v("\n                 " + _vm._s(_vm.$parent.ruleForm.close_date) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "情况备注",
      "prop": "region"
    }
  }, [_vm._v("\n                 " + _vm._s(_vm.$parent.ruleForm.remarks) + "\n              ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7967e051","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bxgl/QtxzCx/Qtxzcx_edit.vue
// module id = null
// module chunks = 